// THIS FILE WAS AUTOGENERATED
"use strict";
export import AvailabilityData = require("./AvailabilityData");
export import Base = require("./Base");
export import ContextTagKeys = require("./ContextTagKeys");
export import Data = require("./Data");
export import DataPoint = require("./DataPoint");
export import DataPointType = require("./DataPointType");
export import Domain = require("./Domain");
export import Envelope = require("./Envelope");
export import EventData = require("./EventData");
export import ExceptionData = require("./ExceptionData");
export import ExceptionDetails = require("./ExceptionDetails");
export import MessageData = require("./MessageData");
export import MetricData = require("./MetricData");
export import PageViewData = require("./PageViewData");
export import RemoteDependencyData = require("./RemoteDependencyData");
export import RequestData = require("./RequestData");
export import SeverityLevel = require("./SeverityLevel");
export import StackFrame = require("./StackFrame");
